import {all, takeEvery} from 'redux-saga/effects'

import {CALL_BACKEND_API} from '../Actions/ApiActionTypes'
import designerSagas from './Designer/designerSagas'
import fetchData from './SagaHelper'
import tikctingFunctonalitySaga from './School/TicktingFunctonality/ticktingFunctonalitySaga'
import academicRecordSagas from './School/academicRecord/academicRecordSagas'
import accountSagas from './School/account/accountSagas'
import accountTypeSagas from './School/account_type/accountTypeSaga'
import actmAccountSettingSagas from './School/actmAccountSetting/actmAccountSettingSagas'
import admissionFeeVoucherDateSagas from './School/admissionFeeVoucherDate/admissionFeeVoucherDate'
import admissionReportSagas from './School/admissionReport/admissionReportSagas'
import admissionSettingsSagas from './School/admissionSettings/admissionSettingsSagas'
import admissionVoucherSagas from './School/admissionVoucher/admissionVoucherSagas'
import assessmentGroupSagas from './School/assessmentGroup/assessmentGroupSagas'
import BiometricCsvLogSagas from './School/biometricCsvLog/biometricCsvLogSagas'
import BiometricDeviceLogSagas from './School/biometricDeviceLog/biometricDeviceLogSagas'
import BiometricLogSagas from './School/biometricLog/biometricLogSagas'
import certificateSagas from './School/certificate/certificateSagas'
import classSagas from './School/class/classSagas'
import clientSecretsSagas from './School/clientSecrets/clientSecretsSagas'
import schoolIntegrationSagas from './School/schoolIntegration/schoolIntegrationSagas'
import csvImportSagas from './School/csvImport/csvImportSagas'
import customNamesSagas from './School/customNames/customNamesSagas'
import dataExportSagas from './School/dataExport/dataExportSagas'
import diagnoseSagas from './School/diagnose/diagnoseSagas'
import digitalRequestSagas from './School/digital_request/digitalRequestSagas'
import eventSagas from './School/event/eventSagas'
import examSagas from './School/exam/examSagas'
import examRemarksSagas from './School/examRemarks/examRemarksSagas'
import examReportSagas from './School/examReport/examReportSagas'
import examReportCardWordTemplateSagas from './School/examReportCardWordTemplate/examReportCardWordTemplateSagas'
import examScheduleSettingSagas from './School/examScheduleSetting/examScheduleSettingSagas'
import examToolsSagas from './School/examTools/examToolsSagas'
import examTypeSagas from './School/examType/examTypeSagas'
import examTypeLabelsSagas from './School/examTypeLabels/examTypeLabelsSagas'
import fileTypeSagas from './School/fileType/fileTypeSagas'
import generationSagas from './School/generation/generationSagas'
import goodsReceiptSagas from './School/goods_receipt/goodsReceiptSagas'
import gradeSaga from './School/grade/gradeSagas'
import inventoryDashboardSagas from './School/inventoryDashboard/inventoryDashboardSagas'
import inventorySettingsSaga from './School/inventorySettings/inventorySettingsSagas'
import invoiceSagas from './School/invoice/invoiceSagas'
import itemCategorySagas from './School/itemCategory/itemCategorySagas'
import labelSagas from './School/label/labelSagas'
import schoolLectureSagas from './School/lecture/lectureSagas'
import levelSaga from './School/level/levelSagas'
import librarySagas from './School/library/librarySagas'
import logSagas from './School/logs/LogSagas'
import moduleNameSagas from './School/module_names/moduleNameSagas'
import multiExamSagas from './School/multiExam/multiExamSagas'
import NewsSagas from './School/news/newsSagas'
import NotificationLogSagas from './School/notificationLog/notifLogSagas'
import schoolUserMParentSagas from './School/parent/parentSagas'
import performanceReportsSagas from './School/performanceReports/performanceReportsSagas'
import purchaseOrderSagas from './School/purchase_order/purchasOrderSagas'
import recheckingSagas from './School/rechecking/recheckingSagas'
import requestSagas from './School/request/requestSagas'
import resourceSagas from './School/resource/resourceSagas'
import resourceArchiveFolderSagas from './School/resourceArchiveFolder/resourceArchiveFolderSagas'
import resourceCategorySagas from './School/resourceCategory/resourceCategorySagas'
import royaltySagas from './School/royalty/royaltySagas'
import schoolScheduleSagas from './School/schedule/scheduleSagas'
import sectionSaga from './School/section/sectionSagas'
import SmsLogSagas from './School/smsLog/smsLogSagas'
import sportsRecordSagas from './School/sportsRecord/sportsRecordSagas'
import staffSagas from './School/staff/staffSagas'
import staffRoleSagas from './School/staff_role/staff_role'
import statsSagas from './School/stats/statsSagas'
import stockLedgerSagas from './School/stockLedger/stockLedgerSagas'
import storeItemSagas from './School/storeItem/storeItemSagas'
import schoolUserMStudentSagas from './School/student/studentSagas'
import studentExamSagas from './School/studentExam/studentExamSagas'
import subjectSagas from './School/subject/subjectSagas'
import subjectGroupSagas from './School/subjectGroup/subjectGroupSagas'
import systemLogSagas from './School/systemLog/systemLogSagas'
import tagSagas from './School/tags/tagSagas'
import tagsCategorySagas from './School/tagsCategory/tagsCategorySagas'
import schoolUserMTeacherSagas from './School/teacher/teacherSagas'
import termSagas from './School/term/termSagas'
import transactionSagas from './School/transaction/transaction'
import schoolUserSagas from './School/user/user'
import vendorSagas from './School/vendor/vendorSagas'
import WhatsappLogSagas from './School/whatsappLog/whatsappLogSagas'
import activitySagas from './activity/activitySagas'
import applicationFeedbackSagas from './applicationFeedback/applicationFeedbackSagas'
import attendanceSagas from './attendance/attendanceSagas'
import attendanceRemarksSagas from './attendanceRemarks/attendanceRemarks.sagas'
import BranchSagas from './branch/branchSagas'
import bulkUploadCsv from './bulkUpload/bulkUploadCsvSagas'
import changeLogSagas from './changeLog/changeLogSagas'
import collegeCounsellingDestinationSagas from './collegeCounsellingDestination/collegeCounsellingDestinationSagas'
import collegeCounsellingPortfolioSagas from './collegeCounsellingPortfolio/collegeCounsellingPortfolioSagas'
import collegeCounsellingSettingsSagas from './collegeCounsellingSettings/collegeCounsellingSettingsSagas'
import dashboardSagas from './dashboard/dashboardSagas'
import dataUploadSagas from './dataUpload/dataUploadSagas'
import documentSagas from './document/documentSagas'
import dynamicVariableSagas from './dynamicVariable/dynamicVariableSagas'
import emailSettingsSaga from './emailSettings/emailSettingsSagas'
import feeSagas from './fee/feeSagas'
import formSagas from './form/formSagas'
import bulkDeleteSagas from './general/bulkDeleteSagas'
import generalSagas from './general/generalSagas'
import homeworkSagas from './homework/homeworkSagas'
import inquirySagas from './inquiry/inquirySagas'
import inquirySettingSagas from './inquirySetting/inquirySettingSagas'
import lecturesSagas from './lectures/lecturesSagas'
import forgotPasswordSaga from './login/forgotPasswordSaga'
import loginSaga from './login/loginSaga'
import monthlyAuditSummary from './monthlyAuditSummary/monthlyAuditSummarySagas'
import notificationSettingsSaga from './notificationSettings/notificationSettingsSagas'
import notificationsSagas from './notifications/notificationsSagas'
import observationSagas from './observation/observationSagas'
import onboardingSagas from './onboarding/onboardingSagas'
import PermissionSagas from './permission/permissionSagas'
import questionSagas from './question/questionSagas'
import roleModulePermissionsSagas from './roleModulePermissions/roleModulePermissionsSagas'
import siteSagas from './site/siteSagas'
import syllabusSagas from './syllabus/syllabusSagas'
import testSagas from './test/testSagas'
import threadSagas from './thread/threadSagas'
import timetableSagas from './timetable/timetableSagas'
import userSagas from './user/userSagas'
import attendanceScheduleSaga from './userCustomAttendanceSchedule/UserCustomAttendanceScheduleSagas'
import userSecurityDetails from './userSecurityDetails/userSecurityDetailsSagas'

function* backendApiCallSaga() {
  yield takeEvery(CALL_BACKEND_API, fetchData)
}

function* rootSaga() {
  yield all([
    backendApiCallSaga(),
    accountTypeSagas(),
    actmAccountSettingSagas(),
    admissionFeeVoucherDateSagas(),
    admissionSettingsSagas(),
    attendanceSagas(),
    attendanceRemarksSagas(),
    attendanceScheduleSaga(),
    classSagas(),
    clientSecretsSagas(),
    schoolIntegrationSagas(),
    collegeCounsellingPortfolioSagas(),
    collegeCounsellingDestinationSagas(),
    collegeCounsellingSettingsSagas(),
    admissionReportSagas(),
    certificateSagas(),
    dashboardSagas(),
    dataUploadSagas(),
    designerSagas(),
    digitalRequestSagas(),
    documentSagas(),
    feeSagas(),
    bulkUploadCsv(),
    bulkDeleteSagas(),
    forgotPasswordSaga(),
    generalSagas(),
    generationSagas(),
    goodsReceiptSagas(),
    gradeSaga(),
    homeworkSagas(),
    invoiceSagas(),
    itemCategorySagas(),
    labelSagas(),
    lecturesSagas(),
    librarySagas(),
    loginSaga(),
    levelSaga(),
    moduleNameSagas(),
    monthlyAuditSummary(),
    notificationsSagas(),
    onboardingSagas(),
    purchaseOrderSagas(),
    performanceReportsSagas(),
    PermissionSagas(),
    roleModulePermissionsSagas(),
    resourceSagas(),
    resourceArchiveFolderSagas(),
    resourceCategorySagas(),
    requestSagas(),
    royaltySagas(),
    schoolLectureSagas(),
    schoolScheduleSagas(),
    schoolUserSagas(),
    schoolUserMStudentSagas(),
    schoolUserMParentSagas(),
    schoolUserMTeacherSagas(),
    sectionSaga(),
    statsSagas(),
    storeItemSagas(),
    siteSagas(),
    staffSagas(),
    staffRoleSagas(),
    subjectSagas(),
    tagSagas(),
    tagsCategorySagas(),
    threadSagas(),
    transactionSagas(),
    userSagas(),
    vendorSagas(),
    logSagas(),
    SmsLogSagas(),
    NotificationLogSagas(),
    notificationSettingsSaga(),
    emailSettingsSaga(),
    NewsSagas(),
    WhatsappLogSagas(),
    BiometricCsvLogSagas(),
    BiometricDeviceLogSagas(),
    BiometricLogSagas(),
    BranchSagas(),
    customNamesSagas(),
    activitySagas(),
    examSagas(),
    examReportCardWordTemplateSagas(),
    dynamicVariableSagas(),
    examTypeSagas(),
    examTypeLabelsSagas(),
    assessmentGroupSagas(),
    academicRecordSagas(),
    studentExamSagas(),
    examReportSagas(),
    examRemarksSagas(),
    recheckingSagas(),
    examToolsSagas(),
    multiExamSagas(),
    fileTypeSagas(),
    termSagas(),
    inventorySettingsSaga(),
    tikctingFunctonalitySaga(),
    testSagas(),
    dataExportSagas(),
    userSecurityDetails(),
    timetableSagas(),
    changeLogSagas(),
    csvImportSagas(),
    accountSagas(),
    observationSagas(),
    formSagas(),
    questionSagas(),
    systemLogSagas(),
    syllabusSagas(),
    subjectGroupSagas(),
    inquirySagas(),
    inquirySettingSagas(),
    eventSagas(),
    applicationFeedbackSagas(),
    sportsRecordSagas(),
    diagnoseSagas(),
    inventoryDashboardSagas(),
    stockLedgerSagas(),
    examScheduleSettingSagas(),
    admissionVoucherSagas(),
  ])
}

export default rootSaga
